import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { refreshDashboard } from "../actions/dashboard";
import {
  Trophy,
  Calendar,
  Users,
  PlayCircle,
  CircleDot,
  Circle,
  Disc,
  Square,
  UserCircle,
  Activity,
  X,
  Menu,
  RefreshCw,
  Volleyball,
} from "lucide-react";
import "bootstrap/dist/css/bootstrap.min.css";
import { CompetitionsList } from "../publicmenu/CompetitionsList";
import RencontresList from "../publicmenu/RencontresList";

function Dashboard2({
  disciplines,
  loading,
  error,
  lastUpdated,
  refreshDashboard,
}) {
  const [activeSection, setActiveSection] = useState("competitions");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Chargement initial
  useEffect(() => {
    refreshDashboard();
  }, [refreshDashboard]);

  // Écoute les notifications de refresh via localStorage
  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === "refreshDashboard") {
        refreshDashboard();
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [refreshDashboard]);

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);

  const handleManualRefresh = () => {
    refreshDashboard();
  };

  const menuItems = [
    { id: "competitions", icon: Trophy, label: "Compétitions" },
    { id: "calendar", icon: Calendar, label: "Calendrier" },
    { id: "result", icon: PlayCircle, label: "Résultats" },
    { id: "teams", icon: Users, label: "Classement" },

    { id: "compet1", icon: Calendar, label: "Calendrier" },
    { id: "compet2", icon: PlayCircle, label: "Résultats" },
    { id: "compet3", icon: Users, label: "Classement" },
    { id: "compet4", icon: Calendar, label: "Calendrier" },
    { id: "compet5", icon: PlayCircle, label: "Résultats" },
    { id: "compet6", icon: Users, label: "Classement" },
  ];

  const disciplineInfoList = [
    {
      name: "DISC1",
      icon: CircleDot,
      color: "linear-gradient(135deg,#28a745,#85e085)",
    },
    {
      name: "DISC2",
      icon: CircleDot,
      color: "linear-gradient(135deg,#ff6b6b,#ff8787)",
    },
    {
      name: "DISC3",
      icon: CircleDot,
      color: "linear-gradient(135deg,#ffcc00,#ff9900)",
    },
    {
      name: "DISC4",
      icon: CircleDot,
      color: "linear-gradient(135deg,#16a085,#48c9b0)",
    },
    {
      name: "DISC5",
      icon: CircleDot,
      color: "linear-gradient(135deg,#ffa502,#ffc371)",
    },
    {
      name: "DISC6",
      icon: CircleDot,
      color: "linear-gradient(135deg,#1e90ff,#63b3ed)",
    },
    {
      name: "DISC7",
      icon: UserCircle,
      color: "linear-gradient(135deg,#8e44ad,#c39bd3)",
    },
  ];

  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const rows = chunkArray(disciplines, 4);

  const handleOpenCompetition = (discCode) => {
    // Ici tu peux soit changer activeSection
    // soit ouvrir une section dédiée à cette discipline
    setActiveSection(discCode);
  };

  return (
    <div
      className="page-wrapper"
      style={{
        backgroundImage: "url('../../assets/persocss/images/bgtitle01.jpg')",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        minHeight: "100vh",
      }}
    >
      <style>{`
        .hover-scale { transition: transform 0.3s ease, box-shadow 0.3s ease; }
        .hover-scale:hover { transform: translateY(-5px); box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3); }
        h2, h3 { color: white; text-shadow: 1px 1px 5px rgba(0,0,0,0.6); }
        .card-title { font-weight: bold; }
        .navbar-custom { background: linear-gradient(90deg,#eff8f1,#85e085); border-radius: 12px; }
        .mobile-menu { position: fixed; top: 0; left: 0; height: 100vh; width: 250px; background: linear-gradient(135deg,#28a745,#85e085); color:white; padding:20px; z-index:1050; }
        .mobile-menu a { display:block; padding:10px 0; font-weight:bold; color:white; text-decoration:none; }
        .mobile-menu a:hover { text-decoration:underline; }
      `}</style>

      {/* NAVBAR */}
      <nav className="navbar navbar-expand-lg navbar-custom shadow-lg">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img
              src={require("../../assets/images/logo3.png")}
              alt="Logo"
              style={{
                height: "40px",
                objectFit: "contain",
                marginRight: "12px",
              }}
            />
          </a>

          <div className="d-flex align-items-center">
            <button
              className="btn btn-outline-dark d-lg-none"
              onClick={toggleMobileMenu}
            >
              <Menu size={24} />
            </button>
          </div>

          <ul className="navbar-nav d-none d-lg-flex">
            {menuItems.slice(0, 4).map((item) => {
              const Icon = item.icon;
              return (
                <li className="nav-item mx-2" key={item.id}>
                  <button
                    className={`btn ${
                      activeSection === item.id ? "btn-success" : "btn-light"
                    }`}
                    onClick={() => setActiveSection(item.id)}
                  >
                    <Icon size={18} className="me-1" /> {item.label}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="mobile-menu">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4>Menu</h4>
            <button className="btn btn-light btn-sm" onClick={toggleMobileMenu}>
              <X size={20} />
            </button>
          </div>
          {menuItems.slice(0, 4).map((item) => {
            const Icon = item.icon;
            return (
              <a
                key={item.id}
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveSection(item.id);
                  setMobileMenuOpen(false);
                }}
              >
                <Icon size={18} className="me-2" />
                {item.label}
              </a>
            );
          })}
        </div>
      )}

      <div className="container mt-4">
        {activeSection === "competitions" && (
          <CompetitionsList
            disciplines={disciplines}
            rows={rows}
            disciplineInfoList={disciplineInfoList}
            loading={loading}
            onOpenCompetition={handleOpenCompetition}
          />
        )}
        {activeSection.startsWith("DISC") && (
          <RencontresList discCode={activeSection} />
        )}
        {activeSection === "compet1" && (
          <h2 className="text-center text-white">📅 Section Calendrier</h2>
        )}
        {activeSection === "compet2" && (
          <h2 className="text-center text-white">📅 Section Calendrier</h2>
        )}
        {activeSection === "compet3" && (
          <h2 className="text-center text-white">📅 Section Calendrier</h2>
        )}
        {activeSection === "compet4" && (
          <h2 className="text-center text-white">📅 Section Calendrier</h2>
        )}
        {activeSection === "compet5" && (
          <h2 className="text-center text-white">📅 Section Calendrier</h2>
        )}
        {activeSection === "compet6" && (
          <h2 className="text-center text-white">📅 Section Calendrier</h2>
        )}
        {activeSection === "calendar" && (
          <h2 className="text-center text-white">📅 Section Calendrier</h2>
        )}
        {activeSection === "result" && (
          <h2 className="text-center text-white">🏆 Section Résultats</h2>
        )}
        {activeSection === "teams" && (
          <h2 className="text-center text-white">👥 Section Classement</h2>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  disciplines: state.dashboard.disciplines,
  loading: state.dashboard.loading,
  error: state.dashboard.error,
  lastUpdated: state.dashboard.lastUpdated,
});

export default connect(mapStateToProps, { refreshDashboard })(Dashboard2);
